(ns shared.core.components.auth0.data
  (:require [shared.core.config :as config]
            [shared.core.reactive :as re]
            [shared.core.router :as router]
            [shared.core.util :as util]
            [clojure.string :as s]))

(def root-path re/auth0-root-path)
(def details-path re/auth0-details-path)
(def token-claims-path (conj root-path :token-claims))
(def admin-role :admin)
(def auth0-details re/auth0-details)

(defn build-redirect-app-state [{:keys [current-route redirect-uri]}]
  (clj->js (cond-> {:appState {:targetRoute (str current-route)}}
                   redirect-uri
                   (assoc :authorizationParams (-> {:redirect-uri redirect-uri}
                                                   (util/->snake_case_string))))))

(defn auth0-token-claims [db]
  (get-in db token-claims-path))

(re/reg-sub
  :auth0/user-
  (fn [db]
    (some-> (auth0-details db) :user)))

(re/reg-sub
  :auth0/loading?-
  (fn [db]
    (some-> (auth0-details db) :is-loading)))

(re/reg-sub
  :auth0/token-claims-
  auth0-token-claims)

(defn auth0-ns-user-email [db]
  (some->> (auth0-token-claims db) :ns-user-email))

(re/reg-sub
  :auth0/ns-user-email-
  auth0-ns-user-email)

(defn auth0-ns-concept-id [db]
  (let [concept-id (some-> (auth0-token-claims db) :ns-organization-metadata :concept-id)]
    (if (= concept-id "all")
      concept-id
      (util/parse-int concept-id))))

(re/reg-sub
  :auth0/ns-concept-id-
  auth0-ns-concept-id)

(defn auth0-ns-roles [db]
  (some->> (auth0-token-claims db) :ns-roles (map util/->kebab-case-keyword) (into #{})))

(re/reg-sub
  :auth0/ns-roles-
  auth0-ns-roles)

(defn auth0-ns-organization-display-name [db]
  (some-> (auth0-token-claims db) :ns-organization-display-name))

(re/reg-sub
  :auth0/ns-organization-display-name-
  auth0-ns-organization-display-name)

(defn auth0-ns-organization-metadata [db]
  (some-> (auth0-token-claims db) :ns-organization-metadata))

(re/reg-sub
  :auth0/ns-organization-metadata-
  auth0-ns-organization-metadata)

(re/reg-sub
  :auth0/get-access-token-silently-
  (fn [db]
    (some-> (re/auth0-details db) :get-access-token-silently)))

(re/reg-sub
  :auth0/logged-in?-
  (fn [db]
    (-> (re/auth0-details db) :is-authenticated true?)))

(re/reg-event-db
  :auth0/set-auth-details re/middleware
  (fn [db [details]]
    (when-let [get-id-token-claims (:get-id-token-claims details)]
      (-> (get-id-token-claims)
          (.then #(if %
                    (let [token-claims (js->clj %)
                          ns-name config/AUTH0_NAMESPACE
                          ns-claims (some->> (keys token-claims)
                                             (filter (fn [tc] (s/starts-with? tc ns-name)))
                                             (map (fn [original-k]
                                                    (let [new-k (->> (s/split original-k #"/") (last) (str "ns-"))]
                                                      [new-k (get token-claims original-k)])))
                                             (into {}))]
                      (re/dispatch [:auth0/set-token-claims (util/->kebab-case-keywords (merge token-claims ns-claims))]))
                    (re/dispatch [:auth0/logout])))
          (.catch #(re/dispatch [:auth0/logout]))))
    (assoc-in db details-path details)))

(re/reg-event-db
  :auth0/set-token-claims re/middleware
  (fn [db [token-claims]]
    (assoc-in db token-claims-path token-claims)))

(re/reg-event-db
  :auth0/login-with-redirect re/middleware
  (fn [db]
    (some-> (auth0-details db)
            :login-with-redirect
            (apply [(build-redirect-app-state {:current-route (router/current-route db)})]))
    db))

(re/reg-event-db
  :auth0/logout re/middleware
  (fn [db]
    (let [{:keys [is-authenticated logout]} (auth0-details db)
          params {:logoutParams {:returnTo (.-origin js/window)}}]
      (when is-authenticated
        (some-> logout (apply [(clj->js params)]))))
    db))

(re/reg-event-db
  :auth0/get-access-token-silently re/middleware
  (fn [db]
    (when-let [get-access-token-silently (:get-access-token-silently (auth0-details db))]
      (.then (get-access-token-silently)
             #(js/console.log %)))
    db))

(re/reg-event-db
  :auth0/clear-token-loading re/middleware
  (fn [db [auth0-event-id]]
    (swap! re/token-loading-ids* disj auth0-event-id)
    db))
